<template>
  <div class="dialog-container">
    <div class="btn">
      <div @click="dialogClick">
        <i class="el-icon-upload2" style="padding-right: 5px"></i>
        <span>数据上传</span>
      </div>
    </div>
    <el-dialog
      class="transtant-input"
      v-drag:common
      title="上传机型数据文件"
      :visible.sync="uploadDialog.visible"
      :close-on-click-modal="false"
      :append-to-body="true"
      width="550px"
      @close="cancelDialog()"
    >
      <el-form :rules="rule" :model="uploadDialog" ref="form">
        <el-form-item label="数据文件" label-width="140px" prop="fileInfo">
          <el-upload
            class="upload"
            ref="upload"
            accept=".xls,.xlsx"
            :action="action"
            name="file"
            :data="formHeader"
            :show-file-list="false"
            :auto-upload="false"
            :on-change="onFileSelectChange"
            :on-success="onFileUploadSuccess"
            :on-error="onFileSelectError"
          >
            <el-input
              placeholder="请选择文件"
              readonly
              style="width: 260px"
              slot="trigger"
              :value="uploadDialog.fileInfo"
            ></el-input>
            <el-link
              underline
              style="margin-left: 10px"
              :style="{
                color: '#fff',
                borderBottom: 'none',
                fontSize: '12px'
              }"
              target="blank"
              :href="downloadUrl"
              download
              >模板下载</el-link
            >
          </el-upload>
        </el-form-item>
        <el-form-item style="margin-bottom: 0;">
          <el-col :span="24" align="right">
            <el-button @click="cancelDialog()" type="info">取消</el-button>
            <el-button
              type="primary"
              @click="submitUpload()"
              :loading="uploadDialog.loading"
              >确认</el-button
            >
          </el-col>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getToken } from '@/utils';
// const apiKey = getToken();
const apiKey = 'test';
export default {
  props: {},
  name: 'uploader',
  data() {
    return {
      radio: '1',
      action: `${process.env.VUE_APP_API_HOST}/windfarm/turbineType/uploadTurbineFile?apiKey=${apiKey}`,
      downloadUrl: `${process.env.VUE_APP_API_HOST}/windfarm/project/getTemplateFile?fileName=turbine.xlsx`,
      uploadDialog: {
        loading: false,
        visible: false,
        fileInfo: ''
      },
      rule: {
        fileInfo: [{ required: true, message: '请上传文件', trigger: 'change' }]
      }
    };
  },
  computed: {
    formHeader() {
      return {
        apiKey: getToken()
      };
    }
  },
  watch: {},
  methods: {
    dialogClick() {
      this.uploadDialog.visible = true;
      this.uploadDialog.loading = false;
      if (this.$refs.form) {
        this.$refs.form.clearValidate();
      }
    },
    onFileSelectChange(val) {
      //console.log(val);
      this.uploadDialog.fileInfo = val.name;
    },
    onFileUploadSuccess(val) {
      this.uploadDialog.loading = false;
      this.uploadDialog.visible = false;
      if (this.$refs.form) {
        this.$refs.upload.clearFiles();
      }
      if (val.code === 0) {
        this.$store.commit('model/UPLOAD_SUCCESS', true);
        this.$message({
          message: '上传成功',
          type: 'success'
        });
      } else {
        this.$message({
          message: val.message,
          type: 'error'
        });
      }
    },
    onFileSelectError() {
      this.uploadDialog.visible = false;
      this.uploadDialog.loading = false;
      this.$message({
        message: '上传文件失败',
        type: 'error'
      });
    },
    submitUpload() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.uploadDialog.loading = true;
          this.$refs.upload.submit();
        }
      });
    },
    cancelDialog() {
      this.uploadDialog.visible = false;
      this.uploadDialog.loading = false;
      this.uploadDialog = {
        ...this.uploadDialog,
        fileInfo: '',
        vendor: '0'
      };
      if (this.$refs.form) {
        this.$refs.upload.clearFiles();
        this.$refs.form.clearValidate();
      }
    }
  }
};
</script>

<style lang="less" scoped>
.dialog-container {
  .btn {
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #444456;
      line-height: 28px;
    }
  }
  /deep/.el-dialog {
    .el-dialog__header {
      text-align: left;
    }
    .el-dialog__body {
      text-align: left;
      background-color: rgba(36, 45, 45, 0.8);
    }
    .import-button {
      margin-left: 20px;
    }
  }
}
/deep/ .el-form {
  margin-top: 20px;
}
/deep/.el-form-item {
  .el-form-item__label {
    color: #444456;
    text-align: center;
  }
  .el-radio {
    color: #fff;
  }
}
/* test */
/deep/.el-input__inner {
  border-bottom: 1px solid #444456 !important;
  color: #444456 !important;
}
/deep/.el-link--inner {
  color: #606266;
}
.file-icon {
  font-size: 24px;
  display: inline-block;
  height: 40px;
  line-height: 40px;
  vertical-align: middle;
}
</style>
